"use client";

import { WhySectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedWhySection from "../Components/GeneratedWhySection";

const Why: FC<WhySectionProps> = (props) => {
  return <GeneratedWhySection {...props} />;
};

export default Why;
